import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { translate } from 'containers/services/translate';
import { get, isEmpty, uniqueId } from 'lodash';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import {
  CivilParty,
  CIVIL_PARTY_FORM,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { isChecked } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { EMPTY_CIVIL_PARTY } from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { isCivilPartyFormValidated } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/form-validations';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import FormValidationButtons from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/FormValidationButtons';
import { DOCUMENT_TYPES } from 'constants/global';
import { VictimType } from 'typings/globalTypes';

export interface AddCivilPartyProps {
  intl: IntlShape;
  victims: VictimType[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  setCivilPartyDocuments: Function;
  civilPartyDocuments: CivilParty[];
  addCivilParty: Function;
  resetUploadedDocument: Function;
  sagisVictimInfo: any;
  isBasicManagement?: boolean;
}

const AddCivilParty: React.FC<AddCivilPartyProps> = (props): JSX.Element => {
  const [civilPartyState, setCivilPartyState] = React.useState<CivilParty>({
    ...EMPTY_CIVIL_PARTY,
    victims: [],
  });

  const [canSaveCivilParty, setCanSaveCivilParty] = React.useState<boolean>(
    false,
  );

  React.useEffect(() => {
    const civilPartyValidation = isCivilPartyFormValidated(civilPartyState);
    setCanSaveCivilParty(civilPartyValidation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [civilPartyState]);

  const handleCheckboxClick = (victimId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const civilParty = { ...civilPartyState };
    const { victims } = civilParty;
    const selectedVictim = (props.victims.find(
      victim => victim.id === victimId,
    ) as unknown) as VictimType;

    if (event.target.checked) {
      victims.push(selectedVictim);
    } else {
      victims.splice(victims.indexOf(selectedVictim), 1);
    }

    setCivilPartyState(civilParty);
  };

  const handleSaveClick = (event: React.SyntheticEvent) => {
    props.setCivilPartyDocuments([
      ...props.civilPartyDocuments,
      civilPartyState,
    ]);

    props.addCivilParty(CIVIL_PARTY_FORM.RECAP);
    setCivilPartyState(EMPTY_CIVIL_PARTY);
  };

  return (
    <>
      <div className="sub_div sub_div_on_writing">
        <span className="text">{translate(messages.victimTitle, props)}</span>
        <div className="check_box_container">
          {!isEmpty(props.victims) &&
            props.victims.map(victim => (
              <FormGroup key={uniqueId()} className="check_box_div">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked(
                        victim.id as number,
                        civilPartyState.victims,
                      )}
                      name="checkedB"
                      color="primary"
                      onChange={handleCheckboxClick(victim.id as number)}
                    />
                  }
                  label={
                    featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
                    !props.isBasicManagement
                      ? `${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimFirstName',
                          '',
                        )} ${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimLastName',
                          '',
                        )}`
                      : `${victim.firstName} ${victim.lastName}`
                  }
                />
              </FormGroup>
            ))}
        </div>
        <UploadDocumentBloc
          document={civilPartyState}
          setDocument={setCivilPartyState}
          index={props.civilPartyDocuments.length}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          docType={DOCUMENT_TYPES.CIVIL}
        />
        <FormValidationButtons
          saveForm={handleSaveClick}
          //TODO: removing this ignore istanbul line once we implement the feature to cancel form
          cancelForm={/* istanbul ignore next */ () => {}}
          disabled={!canSaveCivilParty}
        />
      </div>
    </>
  );
};

export default injectIntl(AddCivilParty);
export { AddCivilParty as InWritingStateComponent };
